import React from 'react'
import { create, search, handLeft } from 'ionicons/icons'
import { IonPage, IonHeader, IonButton, IonIcon, IonContent } from '@ionic/react'
import Toolbar from '../components/Toolbar'
import { useHistory } from 'react-router'
import { WORDS_ROUTER, SIGNALS_ROUTER, ADD_WORD_ROUTER } from '../Routers'

const Home: React.FC = () => {
  const history = useHistory();

  function addWord() {
    history.push(ADD_WORD_ROUTER)
  }

  function showSinals() {
    history.push(SIGNALS_ROUTER)
  }

  function showWords() {
    history.push(WORDS_ROUTER)
  }

  return (
    <IonPage>
      <IonHeader>
        <Toolbar title="Colibras" menuBtn={true} infoBtn={true} />
      </IonHeader>

      <IonContent className="ion-padding">
        <div className="nav-buttons">
          <div className="ion-padding ion-text-center">
            <img width="100px" alt="logo" src="assets/imgs/logo.png" />
          </div>
          <IonButton expand="full" size="large" onClick={() => addWord()}>
            <IonIcon slot="start" icon={create}></IonIcon>
            <span>Adicionar uma Palavra</span>
          </IonButton>
          <br />
          <IonButton expand="full" size="large" onClick={() => showSinals()}>
            <IonIcon slot="start" icon={handLeft}></IonIcon>
            <div className="ion-text-wrap">Buscar por Config. de Mão</div>
          </IonButton>
          <br />
          <IonButton expand="full" size="large" onClick={() => showWords()}>
            <IonIcon slot="start" icon={search}></IonIcon>
            <span>Visualizar Palavras</span>
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default Home
